import { TableFilter, InitialState } from "./tableFilter";
import DateFilter from "../DateFilter";

class DateFilterModel extends TableFilter {
  constructor(initialState = undefined) {
    if (initialState === undefined)
      initialState = new InitialState([{ minDate: "", maxDate: "" }]);
    super(DateFilter, initialState);
  }
}

export default DateFilterModel;
